import APIController from "./APIController"
import SyncHelper from '../Helper/SyncHelper';
import {useWebSocket} from "../Context/WebSocketContext";

const Product = () => {
    //Requesthelper
    const { basicRequest, jsonRequest, getWorkspaceId } = APIController()
    const { readOfflineProducts } = SyncHelper()
    const {isOnline} = useWebSocket()

    const allActiveProducts = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/product/all`);
        return data;
    };

    const fetchProductsByCategory = async (categoryID) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        if (isOnline === false) return readOfflineProducts(categoryID);
        const data = await jsonRequest(`/${workspaceId}/product/category/${categoryID}`);
        return data;
    };

    const addProduct = async (productDTO) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/product`, "POST", productDTO);
        return data;
    };

    const editProduct = async (id, productDTO) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/product/${id}`, "PUT", productDTO);
        return data;
    };

    const editProductStock = async (id, productDTO) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/product/stock/${id}`, "PUT", productDTO);
        return data;
    };

    const deleteProduct = async (id) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/product/${id}`, "DELETE");
        return data;
    };

    return {
        fetchProductsByCategory,
        addProduct,
        editProduct,
        editProductStock,
        deleteProduct,
        allActiveProducts
    }
}

export default Product